import React from "react";
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

import { withRouter } from 'react-router-dom';
import withCurrentUser from '../../../../hocs/with_current_user.js';
import withShowToast from '../../../../hocs/with_show_toast.js';
import withShowModal from '../../../../hocs/with_show_modal.js';
import { compose } from 'redux';

import pageStyles from "../../../styles/page_styles.js";
import { infoPageStyles } from "../../base_info_page.js";

import BaseInfoPage from "../../base_info_page.js";
import { ButtonVariantOutlined } from "../../../../base/buttons/constants.js";
import Button from "../../../../base/buttons/button.js";
import ButtonLink from "../../../../base/links/button_link.js";

import I18n from "../../../../base/i18n.js";

import { PageModel } from "../../../../models/frontend/page_model.js";
import { AdminPageModel } from "../../../../models/frontend/admin/page_model.js";

import ShowPageUseCase from "../../../../use_cases/admin/frontend/pages/show_page_use_case.js";
import SavePageUseCase from "../../../../use_cases/admin/frontend/pages/save_page_use_case.js";
import DeletePageUseCase from "../../../../use_cases/admin/frontend/pages/delete_page_use_case.js";

import AdminRoutes from "../../../routes.js";
import WebRoutes from "../../../../web/routes.js";

const styles = theme => ({
  preview: {
    marginLeft: "20px",
    padding: "4px 15px"
  },
});

class PageInfoPage extends BaseInfoPage {

  loadItem() {
    if(this.identifier) {
      this.processDataLoader(this.showUseCase.execute(this.identifier));
    }
    else {
      this.item.key = "newItem";
      this.setState({
        loading: false
      });
    }
  }

  deleteConfirmMessage() {
    return I18n.t("admin.frontend.page.delete.confirm_message", {
      name: this.dataModel.displayValue(this.item)
    });
  }

  processLoadedItem(result) {
    const { data: { page } } = result;
    this.item = page;
  }

  leftButtons() {
    const { classes } = this.props;
    const { submit, loading } = this.state;

    return <React.Fragment>
      <Button className = { classes.button }
              type = { "submit" }
              disabled = { submit || loading } >
        { I18n.t("action.save") }
      </Button>
      {
        this.item && this.item.slug &&
        <ButtonLink className = { clsx(classes.button, classes.preview) }
                    variant = { ButtonVariantOutlined }
                    to = { WebRoutes.page(this.item) }
                    target = { "_blank" }>
          { I18n.t("shared.preview") }
        </ButtonLink>
      }
    </React.Fragment>
  }

  rightButtons() {
    const { classes } = this.props;
    const { submit, loading } = this.state;

    return <React.Fragment>
      {
        this.identifier &&
          <Button className = { clsx(classes.formButton, classes.delete) }
                disabled = { submit || loading }
                onClick = { this.onDelete } >
          { I18n.t("action.delete") }
        </Button>
      }
    </React.Fragment>
  }
}

PageInfoPage.defaultProps = {
  dataModel: AdminPageModel,
  showUseCase: ShowPageUseCase,
  saveUseCase: SavePageUseCase,
  deleteUseCase: DeletePageUseCase,
  routeFunc: AdminRoutes.page
}

export default compose(
  withRouter,
  withShowToast,
  withCurrentUser,
  withShowModal,
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...infoPageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(PageInfoPage);
